<template>
  <v-container fluid>
    <v-row justify="center" style="margin-top: 100px;">
      <v-col align="center">
        <v-btn @click="clickEnVerRutas()" color="green" block x-large dark>
          <h2>Ver ruta</h2>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

import router from "@/router"

export default {
  name: 'Home',

  methods: {
    clickEnVerRutas() {
      router.replace('/VerRutaActual')
    }
  },
}
</script>
